(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1993],{

/***/ 85807:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bang-gia/ty-gia",
      function () {
        return __webpack_require__(38047);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 38047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _features_journal_price__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35160);

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (_features_journal_price__WEBPACK_IMPORTED_MODULE_0__/* .JournalPriceLayout */ .Z);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2031,8276,4904,6874,5160,9774,2888,179], function() { return __webpack_exec__(85807); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);